
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/situation/[[...slug]]",
      function () {
        return require("private-next-pages/situation/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/situation/[[...slug]]"])
      });
    }
  